import React, { Component } from "react";
import { connect } from "react-redux";
// import { withRouter } from "react-router-dom";

import {
  changeLayout,
  changeTopbarTheme,
  changeLayoutTheme,
  toggleRightSidebar,
  changeLayoutWidth,
} from "../../store/actions";

// Other Layout related Component
import Navbar from "./Navbar";
import Header from "./Header";
import Footer from "./Footer";
import Rightbar from "../CommonForBoth/Rightbar";
import withRouter from "../Common/withRouter";
import BottomNavigationParent from "./MobileNavigation";

class Layout extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isMenuOpened: false
    };
    this.toggleRightSidebar = this.toggleRightSidebar.bind(this);
  }

  /**
  * Open/close right sidebar
  */
  toggleRightSidebar() {
    this.props.toggleRightSidebar();
  }

  // Toggle mobile menu
  toggleMenu = () => {
    this.setState(prevState => ({
      isMenuOpened: !prevState.isMenuOpened
    }));
  };
  componentDidUpdate(prevProps) {
    if (prevProps !== this.props) {
      if (this.props.isPreloader) {
        document.getElementById("preloader").style.display = "block";
        document.getElementById("status").style.display = "block";

        setTimeout(() => {
          document.getElementById("preloader").style.display = "none";
          document.getElementById("status").style.display = "none";
        }, 2500);
      } else {
        document.getElementById("preloader").style.display = "none";
        document.getElementById("status").style.display = "none";
      }

      // Ensure attributes are updated on layout change
      
      document.body.setAttribute("data-layout", "horizontal");
      document.body.setAttribute("data-topbar", "light");
      document.body.setAttribute("data-theme", "parent");
    }
  }


  componentDidMount() {
    // Scroll to top
    window.scrollTo(0, 0);

    // Update document title
    const title = this.props.router.location.pathname;
    let currentPage = title.charAt(1).toUpperCase() + title.slice(2).replaceAll("-", " ");
    document.title = `${currentPage} | Brandstrek`;

    // Set layout to horizontal and topbar to light
    this.props.changeLayout("horizontal");
    this.props.changeTopbarTheme("light");
    this.props.changeLayoutTheme(this.props.theme);
    this.props.changeLayoutWidth(this.props.layoutWidth);

    // Always set `data-layout="horizontal"` & `data-topbar="light"`
    document.body.setAttribute("data-layout", "horizontal");
    document.body.setAttribute("data-topbar", "light");

    if (this.props.showRightSidebar) {
      this.toggleRightSidebar();
    }
  }

  /**
   * Opens the menu - mobile
   */
  openMenu = e => {
    this.setState({ isMenuOpened: !this.state.isMenuOpened });
  };
  render() {
    return (
      <React.Fragment>

        <div id="preloader">
          <div id="status">
            <div className="spinner">
              <i className="ri-loader-line spin-icon"></i>
            </div>
          </div>
        </div>

        <div id="layout-wrapper">
          <Header theme={this.props.topbarTheme}
            isMenuOpened={this.state.isMenuOpened}
            toggleRightSidebar={this.toggleRightSidebar}
            openLeftMenuCallBack={this.openMenu}
          />
          <Navbar menuOpen={this.state.isMenuOpened}  toggleMenu={this.toggleMenu} />
          <div className="main-content">
            {this.props.children}
            <Footer />
            <BottomNavigationParent/>
          </div>
        </div>
        <Rightbar />
      </React.Fragment>
    );
  }
}
const mapStatetoProps = state => {
  return {
    ...state.Layout
  };
};
export default connect(mapStatetoProps, {
  changeTopbarTheme, changeLayoutTheme, toggleRightSidebar, changeLayout, changeLayoutWidth
})(withRouter(Layout));
